var moduleMap = {
	"./ViewsRenderWidget": () => {
		return Promise.all(/* __federation_expose_ViewsRenderWidget */[__webpack_require__.e(6464), __webpack_require__.e(9380), __webpack_require__.e(6621), __webpack_require__.e(8476), __webpack_require__.e(6320), __webpack_require__.e(7464), __webpack_require__.e(4561), __webpack_require__.e(3854), __webpack_require__.e(3749), __webpack_require__.e(771), __webpack_require__.e(8534), __webpack_require__.e(2681), __webpack_require__.e(7258), __webpack_require__.e(8707), __webpack_require__.e(2426), __webpack_require__.e(9490)]).then(() => (() => ((__webpack_require__(69651)))));
	},
	"./FormRenderWidget": () => {
		return Promise.all(/* __federation_expose_FormRenderWidget */[__webpack_require__.e(6464), __webpack_require__.e(9380), __webpack_require__.e(6621), __webpack_require__.e(8476), __webpack_require__.e(6320), __webpack_require__.e(7464), __webpack_require__.e(4561), __webpack_require__.e(3854), __webpack_require__.e(3749), __webpack_require__.e(771), __webpack_require__.e(8534), __webpack_require__.e(2681), __webpack_require__.e(7258), __webpack_require__.e(8707), __webpack_require__.e(2426), __webpack_require__.e(8610)]).then(() => (() => ((__webpack_require__(7500)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};
// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});